import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useCallback, useState } from "react";
import { FiLock, FiSettings } from "react-icons/fi";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { customToast, latinNumber } from "../../../utils/General";
import Tooltip from "../../ToolTip";
import Modal from "../../Modal";
import Input from "../../Input";
import Button from "../../Button";
import { changePassword } from "../../../api/methods/Authentication";
import { hideAll } from "tippy.js";

const SettingsMenu = () => {
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const onToggleShowPassword = useCallback(
    (event) => {
      setShowPassword(event === "down");
    },
    [setShowPassword]
  );

  const setNewPassword = useMutation(["setNewPassword"], {
    mutationFn: changePassword,
    onSettled: (response) => {
      if (response.data.success) {
        customToast("success", 'رمز عبور با موفقیت تغییر یافت!');
        navigate("/login");
        localStorage.clear();
      } else {
        customToast("error", "خطا در تغییر رمز عبور!");
      }
    }
  });

  const onSubmitHandler = async (input) => {
    if (input?.NewPassword !== input?.ConfirmPassword) {
      customToast("error", "رمز عبور جدید با تکرار آن مطابقت ندارد!");
      return;
    }
    if (input?.NewPassword?.length < 4) {
      customToast("error", "رمز عبور جدید باید حداقل 4 کاراکتر باشد!");
      return;
    }
    if (input?.NewPassword?.length >= 4 && input?.NewPassword === input?.ConfirmPassword) {
      await setNewPassword.mutateAsync({
        data: {
          NewPassword: input?.NewPassword
        }

      });
    }
  };

  return (
    <Menu as="div" className="relative inline-block">
      <Tooltip content="تنظیمات">
        <Menu.Button
          aria-label="تنظیمات"
          className="inline-flex py-2 justify-center w-full transform scale-125"
        >
          <FiSettings />
        </Menu.Button>
      </Tooltip>
      <Transition
        afterLeave={() => hideAll()}
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="absolute -left-12 transform w-32 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg border dark:border-borderSolid">
          <div className="px-1 py-1 ">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate("/members")}
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  مدیریت دسترسی
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => setShowModal(true)}
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  تغییر رمز عبور
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
      <Modal
        title
        autoWidth
        isOpen={showModal}
        closemodal={() => {
          setShowModal(false);
          reset();
        }}
        modalCss="!p-0 overflow-hidden dark:text-title mx-auto"
        name="تغییر رمز عبور"
      >
        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <div className="p-3 mt-4 flex flex-col gap-y-2">
            <Input
              type={showPassword ? "text" : "password"}
              register={register}
              name="NewPassword"
              options={{
                required: true,
                onChange: (e) => {
                  e.target.value = latinNumber(e.target.value.trim());
                }
              }}
              textAlign="left"
              onShowPasswordToggle={onToggleShowPassword}
              autoComplete="off"
              forceShowPasswordToggle
              leftIcon={<FiLock color="var(--Brand-Default)" />}
              className="mb-4"
              label="رمز عبور جدید"
              hasError={errors.NewPassword}
              msg="لطفا رمز عبور جدید خود را وارد نمایید"
              disabled={setNewPassword.isLoading}
              readOnly={setNewPassword.isLoading}
            />
            <Input
              type={showPassword ? "text" : "password"}
              register={register}
              name="ConfirmPassword"
              options={{
                required: true,
                onChange: (e) => {
                  e.target.value = latinNumber(e.target.value.trim());
                }
              }}
              textAlign="left"
              onShowPasswordToggle={onToggleShowPassword}
              autoComplete="off"
              forceShowPasswordToggle
              leftIcon={<FiLock color="var(--Brand-Default)" />}
              className="mb-4"
              label="تکرار رمز عبور جدید"
              hasError={errors.ConfirmPassword}
              msg="رمز عبور جدید و تکرار آن باید یکسان باشند"
              disabled={setNewPassword.isLoading}
              readOnly={setNewPassword.isLoading}
            />
            <Button
              as="button"
              type="submit"
              className="w-full"
              loading={setNewPassword.isLoading}
              disabled={setNewPassword.isLoading}
            >
              تغییر
            </Button>
          </div>
        </form>
      </Modal>
    </Menu>
  );
};

export default SettingsMenu;
